import { render, staticRenderFns } from "./BdTableFlutter.vue?vue&type=template&id=4546e986&scoped=true&"
import script from "./BdTableFlutter.vue?vue&type=script&lang=js&"
export * from "./BdTableFlutter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4546e986",
  null
  
)

export default component.exports